// extracted by mini-css-extract-plugin
module.exports = {"list":"AJar","light":"AJcz","item":"AJat","vk":"AJc1","lj":"AJc3","telegram":"AJc5","twitter":"AJc7"};